import { create } from 'zustand';
import useMyProfileStore from './useMyProfileStore';

/* Local-only bookkeeping for the Room Parents & Activity page. Who actually has
   Room Parent access comes from the API (getGroupMember → isNetworkAdmin, what
   the Master dashboard lists); this store holds the grants made here and the
   activity log, which have no endpoint yet, so both start empty. */
const useRoomParentsStore = create((set, get) => ({
  access: [],
  activityLog: [],

  hasAccess: (name) => !!get().access.find((rp) => rp.name === name),

  grantAccess: (entry) => set({ access: [...get().access, entry] }),

  removeAccess: (name) => set({ access: get().access.filter((rp) => rp.name !== name) }),

  logActivity: (action, detail) => {
    const who = useMyProfileStore.getState().me?.user_metadata?.name || 'You';
    set({ activityLog: [{ who, action, detail, when: new Date().toISOString() }, ...get().activityLog] });
  },
}));

export default useRoomParentsStore;
